module.exports = __webpack_public_path__ + "img/dashboard_walkthough.66b94ece.png";